import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import TerminDurumu from "./pages/TerminDurumu";
import Production from "./pages/Production";
import Planlama from "./pages/Planlama";
import Quality from "./pages/Quality";
import YapilanUrunMusterisi from "./pages/YapilanUrunMusterisi";
import FazlaUretim from "./pages/FazlaUretim";
import SekillenecekMakina from "./pages/SekillenecekMakina";
import SekillendirmePlani from "./pages/SekillendirmePlani";
import MakinePerformans from "./pages/MakinePerformans";
import PlanlamaOneri from "./pages/PlanlamaOneri";
import OnerilenBiskuvi from "./pages/OnerilenBiskuvi";
import Stock from "./pages/Stock";
import MakinaKapasitesi from "./pages/MakinaKapasitesi";
import DevirBiskuvi from "./pages/DevirBiskuvi";
import DevirKalitedenGecmeyen from "./pages/DevirKalitedenGecmeyen";
import KgReport from "./pages/KgReport";
import AylikRapor from "./pages/AylikRapor";
import Products from "./pages/Products";
import Users from "./pages/Users";
import RecycleBin from "./pages/RecycleBin";
import Notifications from "./pages/Notifications";
import "./App.css";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-zinc-400">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/siparisler" element={<Protected><Orders /></Protected>} />
      <Route path="/termin-durumu" element={<Protected><TerminDurumu /></Protected>} />
      <Route path="/uretim" element={<Protected><Production /></Protected>} />
      <Route path="/uretim-planlama" element={<Protected><Planlama /></Protected>} />
      <Route path="/kalite" element={<Protected><Quality /></Protected>} />
      <Route path="/yapilan-urun-musterisi" element={<Protected><YapilanUrunMusterisi /></Protected>} />
      <Route path="/fazla-uretim" element={<Protected><FazlaUretim /></Protected>} />
      <Route path="/sekillenecek-makina" element={<Protected><SekillenecekMakina /></Protected>} />
      <Route path="/sekillendirme-plani" element={<Protected><SekillendirmePlani /></Protected>} />
      <Route path="/makine-performans" element={<Protected><MakinePerformans /></Protected>} />
      <Route path="/planlama-oneri" element={<Protected><PlanlamaOneri /></Protected>} />
      <Route path="/onerilen-biskuvi" element={<Protected><OnerilenBiskuvi /></Protected>} />
      <Route path="/stok" element={<Protected><Stock /></Protected>} />
      <Route path="/makina-kapasitesi" element={<Protected><MakinaKapasitesi /></Protected>} />
      <Route path="/devir-biskuvi" element={<Protected><DevirBiskuvi /></Protected>} />
      <Route path="/devir-kaliteden-gecmeyen" element={<Protected><DevirKalitedenGecmeyen /></Protected>} />
      <Route path="/kg-rapor" element={<Protected><KgReport /></Protected>} />
      <Route path="/aylik-rapor" element={<Protected><AylikRapor /></Protected>} />
      <Route path="/malzemeler" element={<Protected><Products /></Protected>} />
      <Route path="/kullanicilar" element={<Protected><Users /></Protected>} />
      <Route path="/geri-donusum" element={<Protected><RecycleBin /></Protected>} />
      <Route path="/bildirimler" element={<Protected><Notifications /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
